module.exports = __webpack_public_path__ + "static/media/restaurant-1.af4e2f7c.jpg";